import { ApiProperty, IntersectionType } from '@nestjs/swagger';
import { PhaseInterface } from '../interfaces/phase.interface';
import { CommonEntityDto } from '../../common/dto/common-entity.dto';
import { JobPhaseDto } from '../../job-phase/dto/job-phase.dto';
import {
  IsBoolean,
  IsEnum,
  IsNumber,
  IsString,
  Max,
  MaxLength,
  Min,
  MinLength,
} from 'class-validator';
import { Exclude, Expose, Type } from 'class-transformer';
import {
  PHASE_NAME_MIN_LENGTH,
  PHASE_NAME_MAX_LENGTH,
  PHASE_DESCRIPTION_MIN_LENGTH,
  PHASE_DESCRIPTION_MAX_LENGTH,
  PHASE_PRIORITY_MIN,
  PHASE_PRIORITY_MAX,
} from '../constants/phase-validation.constants';
import { ContractorResourceTypeEnum } from '../../contractor/enums/contractor-resource-type.enum';
import { PhaseTypeEnum } from '../enums/phase-type.enum';
import { FlowRuleCommonDto } from '../../flow-rule-common/dto/flow-rule-common.dto';
import { PhaseStructureTypeEnum } from '../enums/phase-structure-type.enum';
import { PhaseCategoryEnum } from '../enums/phase-category.enum';

@Exclude()
export class PhaseDto
  extends IntersectionType(CommonEntityDto, FlowRuleCommonDto)
  implements PhaseInterface
{
  @ApiProperty({
    type: 'string',
    title: 'Name',
    description: 'The name of the Phase',
    minLength: PHASE_NAME_MIN_LENGTH,
    maxLength: PHASE_NAME_MAX_LENGTH,
  })
  @IsString()
  @MinLength(PHASE_NAME_MIN_LENGTH)
  @MaxLength(PHASE_NAME_MAX_LENGTH)
  @Expose()
  name!: string;

  @ApiProperty({
    type: 'enum',
    enum: PhaseTypeEnum,
    title: 'Phase Type',
    description: 'The type of this Phase',
  })
  @IsEnum(PhaseTypeEnum)
  @Expose()
  phaseType!: PhaseTypeEnum;

  @ApiProperty({
    type: 'enum',
    enum: PhaseStructureTypeEnum,
    title: 'Phase Structure Type',
    description: 'Phase Structure Type',
  })
  @IsEnum(PhaseStructureTypeEnum)
  @Expose()
  phaseStructureType!: PhaseStructureTypeEnum;

  @ApiProperty({
    type: 'enum',
    enum: PhaseCategoryEnum,
    title: 'Phase Category Type',
    description: 'Phase Category Type',
  })
  @IsEnum(PhaseCategoryEnum)
  @Expose()
  phaseCategory!: PhaseCategoryEnum;

  @ApiProperty({
    type: 'string',
    nullable: true,
    title: 'Description',
    description: 'The description of the Phase',
    minLength: PHASE_DESCRIPTION_MIN_LENGTH,
    maxLength: PHASE_DESCRIPTION_MAX_LENGTH,
  })
  @IsString()
  @MinLength(PHASE_DESCRIPTION_MIN_LENGTH)
  @MaxLength(PHASE_DESCRIPTION_MAX_LENGTH)
  @Expose()
  description!: string | null;

  @ApiProperty({
    type: 'number',
    title: 'Priority',
    description: 'The priority of this Phase',
    minimum: PHASE_PRIORITY_MIN,
    maximum: PHASE_PRIORITY_MAX,
  })
  @IsNumber()
  @Min(PHASE_PRIORITY_MIN)
  @Max(PHASE_PRIORITY_MAX)
  @Expose()
  priority!: number;

  @ApiProperty({
    type: 'enum',
    enum: ContractorResourceTypeEnum,
    nullable: true,
    title: 'Resource Type',
    description: 'The resource type of this Phase',
  })
  @IsEnum(ContractorResourceTypeEnum)
  @Expose()
  resourceType!: ContractorResourceTypeEnum | null;

  @ApiProperty({ type: () => [JobPhaseDto], required: false })
  @Expose()
  jobPhases?: JobPhaseDto[];
}
